/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_Failed_ToastInputs */

const en_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to merge speakers`)
};

const fr_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de la fusion des locuteurs`)
};

const de_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen der Sprecher fehlgeschlagen`)
};

const it_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile unire gli altoparlanti`)
};

const ru_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось объединить динамики`)
};

const es_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron fusionar los altavoces`)
};

const zh_cn2_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并发言者失败`)
};

const ja_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを結合できませんでした`)
};

const hi_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं को मर्ज करने में विफल`)
};

const pt_pt2_speaker_manager_merge_failed_toast = /** @type {(inputs: Speaker_Manager_Merge_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao mesclar os alto-falantes`)
};

/**
* | output |
* | --- |
* | "Failed to merge speakers" |
*
* @param {Speaker_Manager_Merge_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_failed_toast = /** @type {((inputs?: Speaker_Manager_Merge_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_merge_failed_toast(inputs)
	if (locale === "de") return de_speaker_manager_merge_failed_toast(inputs)
	if (locale === "it") return it_speaker_manager_merge_failed_toast(inputs)
	if (locale === "ru") return ru_speaker_manager_merge_failed_toast(inputs)
	if (locale === "es") return es_speaker_manager_merge_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_merge_failed_toast(inputs)
	if (locale === "ja") return ja_speaker_manager_merge_failed_toast(inputs)
	if (locale === "hi") return hi_speaker_manager_merge_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_merge_failed_toast(inputs)
	return en_speaker_manager_merge_failed_toast(inputs)
});